export default "__VITE_ASSET__CXNXPQlG__"